import { render, staticRenderFns } from "./ContentsUnattached.vue?vue&type=template&id=068690d0&scoped=true&"
import script from "./ContentsUnattached.vue?vue&type=script&lang=js&"
export * from "./ContentsUnattached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068690d0",
  null
  
)

export default component.exports